import { Node } from 'tiptap';
import MergeValueView from '@/editor/tiptap/nodes/MergeValueView.vue';
import { IField, IMergeValues } from '@/editor/types';

export default class MergeValueNode extends Node {
  constructor(
    options = {
      mergeValues: {} as IMergeValues,
      fields: [] as IField[],
    }
  ) {
    super(options);
  }

  get name() {
    return 'merge_tag';
  }

  get schema() {
    return {
      attrs: {
        tagId: {
          default: '',
        },
        category: {
          default: '',
        },
        mergeKey: {
          default: '',
        },
      },
      group: 'inline',
      inline: true,
      selectable: true,
      draggable: false,
      parseDOM: [
        {
          tag: 'span.merge-tag',
          getAttrs: dom => ({
            tagId: dom.getAttribute('tagId'),
            category: dom.getAttribute('category'),
            mergeKey: dom.getAttribute('mergeKey'),
          }),
        },
      ],
      toDOM: node => ['span', { ...node.attrs, class: 'merge-tag' }],
    };
  }

  // Override default behavior and let all events through
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  stopEvent() {}

  get view() {
    return MergeValueView;
  }
}
